import ApiConstant from "../../constants/api.constants";
import api from "../api";
import { CustomerReportResponse } from "../../models/all-user/edit-user-model";
import { CustomerFollowupParams } from "../../models/orders/order-list-model";
import { CustomerFollowupResponse } from "../../models/orders/order-list-model";

const getUsers = async (filter: string) => {
  try {
    const allUsers: any = await api
      .get(ApiConstant.getAllUser + filter)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get users', error);
      });
    const response = allUsers != null ? allUsers : null;
    return response;
  }
  catch (e) {
    console.log('error in getUsers');
    return [];
  }
}

const updateUser = async (userId: number, data: any) => {
  try {
    const updatedUser: any = await api
      .put(`${ApiConstant.updateUser}/${userId}`, data)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error updating User data', error);
      });
    const response = updatedUser != null ? updatedUser : null;
    return response;
  }
  catch {
    console.log('error in edit user');
    return false;
  }
}

const deleteUser = async (userId: number) => {
  try {
    const deleteUser: any = await api
      .delete(ApiConstant.deleteUserDetail + userId)
      .then((res: any) => {
        if (res)
          return res.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error deleting user.', error);
      });
    const response = deleteUser != null ? deleteUser : null;
    return response;
  }
  catch {
    console.log('error in delete user detail');
    return false;
  }
}

const getNewUsersList = async (filter: any) => {
  try {
    const Users: any = await api
      .post(ApiConstant.getNewUsersList, filter)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get order user list data.', error);
      });
    const response = Users != null ? Users : null;
    return response;
  }
  catch (e) {
    console.log('error in getUserDaateData');
    return [];
  }
}


const getCustomerReport = async (): Promise<CustomerReportResponse> => {
  try {
    const { data } = await api.get<CustomerReportResponse>(ApiConstant.customerReport);
    return data || { columns: [], data: [] };
  }
  catch (error) {
    console.error('Error fetching customer report:', error);
    return {
      columns: [],
      data: []
    };

  }
};

const getCustomerFollowup = async (
  params: CustomerFollowupParams
): Promise<CustomerFollowupResponse> => {
  try {
    const { data } = await api.post<CustomerFollowupResponse>(
      ApiConstant.getcustomerfollowup,
      params
    );
    return data || {
      followups: [],
      totalRecords: 0,
      maxRecentOrderAmount: 0,
      message: '',
      isSuccess: false
    };
  } catch (error) {
    console.error('Error fetching customer follow-up:', error);
    return {

      followups: [],
      totalRecords: 0,
      maxRecentOrderAmount: 0,
      message: 'Failed to fetch data',
      isSuccess: false
    };
  }
};
const getCallStatuses = async () => {
  try {
    const callStatuses: any = await api
      .get(ApiConstant.getcallstatus)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading get call status data.', error);
      });
    const response = callStatuses != null ? callStatuses : null;
    return response;
  }
  catch (e) {
    console.log('error in getCallStatuses');
    return [];
  }
}
const getDeliveryExecutives = async () => {
  try {
    const deliveryExecutives: any = await api
      .get(ApiConstant.getDeliveryExecutives)
      .then((result: any) => {
        if (result)
          return result.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error reading delivery executives data.', error);
      });
    const response = deliveryExecutives != null ? deliveryExecutives : null;
    return response;
  }
  catch (e) {
    console.log('error in getDeliveryExecutives');
    return [];
  }
}
interface CreateCallHistoryResponse {
  isSuccess: boolean;
  id?: number;
  message?: string;
}

const createCallHistory = async (callHistoryData: {
  customerId: number;
  callStatusId: number;
}): Promise<CreateCallHistoryResponse> => {
  try {
    const response = await api.post(ApiConstant.savecallhistory, callHistoryData);
    return {
      isSuccess: response.data?.isSuccess ?? false,
      id: response.data?.id,
      message: response.data?.message
    };
  } catch (error: any) {
    console.error("Error creating call history", error);
    return {
      isSuccess: false,
      message: error?.response?.data?.message || "Something went wrong"
    };
  }
};

export interface RequestInput {
  startDate: string;
  endDate: string;
  pageNumber: number;
  pageSize: number;
}

export interface Response {
  customerExecutive: string;
  taxableAmount: number;
}
export interface CustomerDetails {
  customerExecutive: string;
  customerName: string;
  customerNumb: string;
  invoicedBy: string;
  taxableAmount: number;
}
export interface CustomerSalesReportResponse {
  totalRecords: number;
  salesReports: CustomerDetails[];
}
export const CustomerExecutiveSalesReport1 = async (filter: RequestInput): Promise<Response[]> => {
  try {
    const response = await api.post(ApiConstant.CustomerExecutiveSalesReport1, filter);
    if (response?.data && Array.isArray(response.data)) {
      return response.data as Response[];
    }
    return [];
  } catch (error) {
    console.error("Error fetching sales list:", error);
    return [];
  }
};
export const CustomerExecutiveSalesReport2 = async (
  filter: RequestInput
): Promise<CustomerSalesReportResponse> => {
  try {
    const response = await api.post(ApiConstant.CustomerExecutiveSalesReport2, filter);

    if (response?.data && typeof response.data === "object") {
      return response.data as CustomerSalesReportResponse;
    }

    return { totalRecords: 0, salesReports: [] };
  } catch (error) {
    console.error("Error fetching sales list:", error);
    return { totalRecords: 0, salesReports: [] };
  }
};

export interface CustomerDetails1 {
  userID: number;
  invoicedBy: string;
  taxableAmount: number;
  rewardsRedeemed:number;
  cashCollected:number
}

export interface CustomerSalesReportResponse1 {
  totalRecords: number;
  salesReports: CustomerDetails1[];
}


export const InvoicedBySalesReport = async (
  filter: RequestInput
): Promise<CustomerSalesReportResponse1> => {
  try {
    const response = await api.post(ApiConstant.CustomerExecutiveSalesReport3, filter);

    if (response?.data && typeof response.data === "object") {
      return {
        totalRecords: response.data.totalRecords,
        salesReports: response.data.records,
      };
    }
    return { totalRecords: 0, salesReports: [] };
  } catch (error) {
    console.error("Error fetching invoiced-by sales report:", error);
    return { totalRecords: 0, salesReports: [] };
  }
};

export const getSalesExecutiveTargets = async (filter: { year: number; month: number }) => {

  try {
    const response = await api.post(ApiConstant.GetCETargetMappping, filter)
      .then((result: any) => {
        if (result) {
          return result.data;
        }
        return null;
      })
      .catch((error: any) => {
        console.error('Error fetching sales executive targets:', error);
        throw error;
      });

    return response || [];
  } catch (e) {
    console.error('Error in getSalesExecutiveTargets:', e);
    return [];
  }
};



export const updateSalesExecutiveTarget = async (payload: {
  salesExecutiveId: number;
  salesTarget: number;
  salesYear: number;
  salesMonth: number;
}) => {
  try {

    const response = await api.put(ApiConstant.UpdateTarget, payload)
      .then((result: any) => result?.data || {})
      .catch((error: any) => {
        console.error('Error updating sales target:', error);
        throw error;
      });

    return response;
  } catch (e) {
    console.error('Error in updateSalesExecutiveTarget:', e);
    return {};
  }
};

export interface CEPerformanceReportRequest {
  salesMonth: number;
  salesYear: number;
}

export interface CEPerformanceReportResponseItem {
  salesExecutiveID: number;
  customerServiceExecutive: string;
  targetForTheMonth: number;
  invoicedForTheDay: number;
  invoicedTillDate: number;
  balanceTargetToAchieve: number;
  achievedPercent: number;
  openOrderAsOnDate: number;
  callCountForTheDay: number;
  callCountMonthTillDate: number;
  totalAssignedCustomers: number;
  reportDate: string;
  monthStartDate: string;
}

export interface UnassignedCustomerReport {
  uC_InvoicedForTheDay: number;
  uC_InvoicedTillDate: number;
  uC_OpenOrderForPeriod: number;
}

export interface CEPerformanceReportResult {
  executives: CEPerformanceReportResponseItem[];
  unassignedCustomers: UnassignedCustomerReport;
}

export const CEPerformanceReport1 = async (
  requestData: CEPerformanceReportRequest
): Promise<CEPerformanceReportResult> => {
  try {
    const response = await api.post(ApiConstant.CEPerformanceReport1, requestData);
    const executives: CEPerformanceReportResponseItem[] =
      response.data?.executives?.map((item: any) => ({
        salesExecutiveID: item.salesExecutiveID,
        customerServiceExecutive: item.customerServiceExecutive,
        targetForTheMonth: item.targetForTheMonth ?? 0,
        invoicedForTheDay: item.invoicedForTheDay ?? 0,
        invoicedTillDate: item.invoicedTillDate ?? 0,
        balanceTargetToAchieve: item.balanceTargetToAchieve ?? 0,
        achievedPercent: item.achievedPercent ?? 0,
        openOrderAsOnDate: item.openOrderAsOnDate ?? 0,
        callCountForTheDay: item.callCountForTheDay ?? 0,
        callCountMonthTillDate: item.callCountMonthTillDate ?? 0,
        totalAssignedCustomers: item.totalAssignedCustomers ?? 0,
        reportDate: item.reportDate,
        monthStartDate: item.monthStartDate
      })) ?? [];

    const unassigned: UnassignedCustomerReport = {
      uC_InvoicedForTheDay: response.data?.unassignedCustomers?.uC_InvoicedForTheDay ?? 0,
      uC_InvoicedTillDate: response.data?.unassignedCustomers?.uC_InvoicedTillDate ?? 0,
      uC_OpenOrderForPeriod: response.data?.unassignedCustomers?.uC_OpenOrderForPeriod ?? 0
    };

    return {
      executives,
      unassignedCustomers: unassigned
    };
  } catch (error: any) {
    console.error("Error fetching CE performance report:", error);
    return {
      executives: [],
      unassignedCustomers: {
        uC_InvoicedForTheDay: 0,
        uC_InvoicedTillDate: 0,
        uC_OpenOrderForPeriod: 0
      }
    };
  }
};


export interface CardForCEReportResponse {
  total_CustomersCalledWithinRange: number;
  total_TotalTaxableAmount: number;
  total_TotalTaxableAmountFromReachedCustomers: number;
}

export const getCardForCEReport = async (
  requestData: CEPerformanceReportRequest
): Promise<CardForCEReportResponse | null> => {
  try {
    const response = await api.post(ApiConstant.CardforCEReport, requestData);

    if (!response.data) {
      return null;
    }

    return {
      total_CustomersCalledWithinRange: response.data.total_CustomersCalledWithinRange ?? 0,
      total_TotalTaxableAmount: response.data.total_TotalTaxableAmount ?? 0,
      total_TotalTaxableAmountFromReachedCustomers: response.data.total_TotalTaxableAmountFromReachedCustomers ?? 0
    };
  } catch (error: any) {
    console.error("Error fetching CE performance card report:", error);
    return null;
  }
};

export interface CECallStatusPivotRequest {
  month: number;
  year: number;
}

export interface CECallStatusPivotResponseItem {
  callStatusId: number;
  callStatusName: string;
  ceCounts: {
    [ceName: string]: number;
  };
}

export const getCECallStatusPivot = async (
  requestData: CECallStatusPivotRequest
): Promise<CECallStatusPivotResponseItem[]> => {
  try {
    const response = await api.post(ApiConstant.GetStatusAnalysis, requestData);

    return response.data?.map((item: any) => ({
      callStatusId: item.callStatusId,
      callStatusName: item.callStatusName,
      ceCounts: item.ceCounts ?? {}
    })) ?? [];
  } catch (error: any) {
    console.error('Error fetching CE call status pivot:', error);
    return [];
  }
};

export interface CEDailyActivityTopcardRequest {
  salesExecutiveId?: number;
  startDate: string;
  endDate: string;
}

export interface CEDailyActivityTopcardResponse {
  totalCustomersCalledWithinRange: number;
  totalTaxableAmount: number;
  totalTaxableAmountFromReachedCustomers: number;
  totalTaxableAmountByOthers: number;
}

export const getCEDailyActivityTopcard = async (
  requestData: CEDailyActivityTopcardRequest
): Promise<CEDailyActivityTopcardResponse | null> => {
  try {
    const response = await api.post(ApiConstant.GetCEDailyActivityTopcard, requestData);

    return {
      totalCustomersCalledWithinRange: response.data?.totalCustomersCalledWithinRange ?? 0,
      totalTaxableAmount: response.data?.totalTaxableAmount ?? 0,
      totalTaxableAmountFromReachedCustomers: response.data?.totalTaxableAmountFromReachedCustomers ?? 0,
      totalTaxableAmountByOthers: response.data?.totalTaxableAmountByOthers ?? 0
    };
  } catch (error: any) {
    console.error("Error fetching CE Daily Activity Topcard:", error);
    return null;
  }
};

export interface CEDailyActivityStatusCard {
  callStatusId: number;
  callStatusName: string;
  customerCount: number;
}
export const getCEDailyActivityStatusCards = async (
  requestData: CEDailyActivityTopcardRequest
): Promise<CEDailyActivityStatusCard[]> => {
  try {
    const response = await api.post(ApiConstant.GetCEDailyActivityStatusCards, requestData);
    return response.data?.map((item: any) => ({
      callStatusId: Number(item.callStatusId),
      callStatusName: item.callStatusName,
      customerCount: item.customerCount ?? 0
    })) ?? [];
  } catch (error: any) {
    console.error("Error fetching CE Daily Activity Status Cards:", error);
    return [];
  }
};

export interface CustomerCallStatusRequest {
  salesExecutiveId?: number;
  startDate: string;
  endDate: string;
  callStatusId?: number;
  sortColumn: string,
  sortDirection: string,
  pageNumber: number;
  pageSize: number;
}

export interface CustomerCallStatusResponseItem {
  customerId: number;
  customerName: string;
  contactNumber: string;
  orderID?: string | null;
  orderDate?: string | null;
  taxableAmount?: string | null;
  lastCalledDate: string;
  dynamicColumns?: Record<string, string>;
}

export interface CustomerCallStatusResponse {
  data: CustomerCallStatusResponseItem[];
  totalCount: number;
}

export const getCustomerCallStatusSummary = async (
  requestData: CustomerCallStatusRequest
): Promise<CustomerCallStatusResponse> => {
  try {
    const response = await api.post(ApiConstant.GetSummaryCardDetails, requestData);

    // Map the response data to include dynamicColumns
    const mappedData = response.data?.data?.map((item: any) => ({
      customerId: item.customerId,
      customerName: item.customerName,
      contactNumber: item.contactNumber,
      orderID: item.orderID || null,
      orderDate: item.orderDate || null,
      taxableAmount: item.taxableAmount || null,
      lastCalledDate: item.lastCalledDate,
      dynamicColumns: item.dynamicColumns || {}
    })) || [];

    return {
      data: mappedData,
      totalCount: response.data?.totalCount ?? 0
    };
  } catch (error: any) {
    console.error("Error fetching Customer Call Status Summary:", error);
    return { data: [], totalCount: 0 };
  }
};


export interface SalesExecutiveDailyReportRequest {
  salesExecutiveId?: number;
  startDate: string;
  endDate: string;
}

interface SalesExecutiveDailyReport {
  reportDate: string;
  salesExecutiveID: number;
  salesExecutiveName: string;
  callCount: number;
  orderValue: number;
  invoiceValue: number;
}

export const getSalesExecutiveDailyReport = async (
  requestData: SalesExecutiveDailyReportRequest
): Promise<SalesExecutiveDailyReport[]> => {
  try {
    const response = await api.post(ApiConstant.GetDateWisecalldetails, requestData);

    return response.data?.map((item: any) => ({
      reportDate: item.reportDate,
      salesExecutiveID: item.salesExecutiveID,
      salesExecutiveName: item.salesExecutiveName,
      callCount: item.callCount ?? 0,
      orderValue: item.orderValue ?? 0,
      invoiceValue: item.invoiceValue ?? 0
    })) ?? [];
  } catch (error: any) {
    console.error("Error fetching Sales Executive Daily Report:", error);
    return [];
  }
};


export interface UnassignedCustomerRequest {
  year: number;
  month: number;
  pageNumber: number;
  pageSize: number;
  sortColumn: string;
  sortDirection: string;
}

export interface UnassignedCustomerDto {
  userID: number;
  name: string;
  primaryContactNbr: string;
  areaName: string;
  subDistrictName: string;
  stateName: string;
}

export interface UnassignedCustomerResponse {
  data: UnassignedCustomerDto[];
  totalRecords: number;
}
export const getUnassignedCustomers = async (
  requestData: UnassignedCustomerRequest
): Promise<UnassignedCustomerResponse> => {
  try {
    const response = await api.post(ApiConstant.GetUnassignedcustomers, requestData);
    const data = response.data?.data?.map((item: any) => ({
      userID: item.userID,
      name: item.name ?? "",
      primaryContactNbr: item.primaryContactNbr ?? "",
      areaName: item.areaName ?? "",
      subDistrictName: item.subDistrictName ?? "",
      stateName: item.stateName ?? ""

    })) ?? [];

    const totalRecords = response.data?.totalRecords ?? 0;

    return {
      data,
      totalRecords
    };
  } catch (error: any) {
    console.error("Error fetching Unassigned Customers:", error);
    return {
      data: [],
      totalRecords: 0
    };
  }
};

export interface LastOrderResponse {
  orderID: number;
  createdDate: string;
  taxableAmount: number;
  createdByName: string;
}

export const getLastFiveOrdersfromuserid = async (userId: number): Promise<LastOrderResponse[]> => {
  if (!userId) return [];
  try {
    const url = `${ApiConstant.GetlastFiveOrders}/${userId}`;
    const { data } = await api.get<LastOrderResponse[]>(url);
    return data;
  } catch (error) {
    console.error("Error fetching last 5 orders:", error);
    return [];
  }
};

export interface OrderByOthersRequest {
  salesExecutiveId?: number;
  startDate: string;
  endDate: string;
  pageNumber: number;
  pageSize: number;
  sortColumn: string;
  sortDirection: "asc" | "desc";
}

export interface OrderByOthersItem {
  userID: number;
  customerName: string;
  primaryContactNbr: string;
  orderID: number;
  taxableAmount: number;
  orderDate: string;
  orderCreatedBy: string;
  lastCalledDate: string | null;
  lastCalledStatus: string | null;
  calledBy: string | null;
}

export interface OrderByOthersResponse {
  totalRecords: number;
  data: OrderByOthersItem[];
}

export const TotalOrderValue = async (
  requestData: OrderByOthersRequest
): Promise<OrderByOthersResponse> => {
  try {
    const response = await api.post(ApiConstant.GetTotalOrderValue, requestData);
    const data: OrderByOthersItem[] = response.data.data?.map((item: any) => ({
      userID: item.userID,
      customerName: item.customerName,
      primaryContactNbr: item.primaryContactNbr,
      orderID: item.orderID,
      taxableAmount: item.taxableAmount,
      orderDate: item.orderDate,
      orderCreatedBy: item.orderCreatedBy,
      lastCalledDate: item.lastCalledDate ?? null,
      lastCalledStatus: item.lastCalledStatus ?? null,
      calledBy: item.calledBy ?? null
    })) ?? [];

    return {
      totalRecords: response.data.totalRecords ?? 0,
      data
    };
  } catch (error: any) {
    console.error("Error fetching Orders By Others:", error);
    return {
      totalRecords: 0,
      data: []
    };
  }
};
export const getOrderByMe = async (
  requestData: OrderByOthersRequest
): Promise<OrderByOthersResponse> => {
  try {
    const response = await api.post(ApiConstant.GetOrderByMe, requestData);
    const data: OrderByOthersItem[] = response.data.data?.map((item: any) => ({
      userID: item.userID,
      customerName: item.customerName,
      primaryContactNbr: item.primaryContactNbr,
      orderID: item.orderID,
      taxableAmount: item.taxableAmount,
      orderDate: item.orderDate,
      orderCreatedBy: item.orderCreatedBy,
      lastCalledDate: item.lastCalledDate ?? null,
      lastCalledStatus: item.lastCalledStatus ?? null,
      calledBy: item.calledBy ?? null
    })) ?? [];

    return {
      totalRecords: response.data.totalRecords ?? 0,
      data
    };
  } catch (error: any) {
    console.error("Error fetching Orders By ME:", error);
    return {
      totalRecords: 0,
      data: []
    };
  }
};

export const getOrderByOthers = async (
  requestData: OrderByOthersRequest
): Promise<OrderByOthersResponse> => {
  try {
    const response = await api.post(ApiConstant.GetOrderByOthers, requestData);
    const data: OrderByOthersItem[] = response.data.data?.map((item: any) => ({
      userID: item.userID,
      customerName: item.customerName,
      primaryContactNbr: item.primaryContactNbr,
      orderID: item.orderID,
      taxableAmount: item.taxableAmount,
      orderDate: item.orderDate,
      orderCreatedBy: item.orderCreatedBy,
      lastCalledDate: item.lastCalledDate ?? null,
      lastCalledStatus: item.lastCalledStatus ?? null,
      calledBy: item.calledBy ?? null
    })) ?? [];

    return {
      totalRecords: response.data.totalRecords ?? 0,
      data
    };
  } catch (error: any) {
    console.error("Error fetching Orders By ME:", error);
    return {
      totalRecords: 0,
      data: []
    };
  }
};
const updateCustomerFlagCode = async (userID: number, flagCode: number) => {
  try {
    const response = await api.put(ApiConstant.UpdateCustomerFlagCode, { UserID: userID, FlagCode: flagCode });
    return response?.data ?? { isSuccess: false, message: "No response" };
  } catch (error: any) {
    console.error("Error updating customer flag code:", error);
    return { isSuccess: false, message: error?.response?.data?.message || error?.message || "Something went wrong" };
  }
};

export interface FlagHistoryItem {
  auditID: number;
  flagCode: number;
  comments: string | null;
  updatedByName: string | null;
  updateDate: string | null;
  actionType: string;  // 'I' = Initial create, 'U' = Update, 'C' = Current
  createdByName?: string | null;  // Name of who originally created the flag
  createdDate?: string | null;    // Original creation date
}

// Saves flag change + mandatory comment to userFlagStatus table
// and also updates the FlagCode on the user record in one call.
const saveFlagWithComment = async (
  userID: number,
  flagCode: number,
  comment: string | null
): Promise<{ isSuccess: boolean; message: string }> => {
  try {
    const response = await api.post(ApiConstant.SaveUserFlagStatus, {
      UserID: userID,
      FlagCode: flagCode,
      Comments: comment
    });
    return response?.data ?? { isSuccess: false, message: "No response" };
  } catch (error: any) {
    console.error("Error saving flag with comment:", error);
    return {
      isSuccess: false,
      message: error?.response?.data?.message || error?.message || "Something went wrong"
    };
  }
};

// Retrieves all flag state changes for a given user ordered by most recent first
const getFlagHistory = async (userID: number): Promise<FlagHistoryItem[]> => {
  try {
    const response = await api.get(`${ApiConstant.GetUserFlagHistory}?userID=${userID}`);
    return response?.data ?? [];
  } catch (error: any) {
    console.error("Error fetching flag history:", error);
    return [];
  }
};

const exportAllCustomers = async (filter: { startDate?: string; endDate?: string }) => {
  try {
    const result: any = await api
      .post(ApiConstant.exportAllCustomers, filter)
      .then((res: any) => (res ? res.data : null))
      .catch((error: any) => {
        console.error('error exporting customers', error);
      });
    return result != null ? result : [];
  } catch (e) {
    console.log('error in exportAllCustomers');
    return [];
  }
};

const editUserServices = {
  getUsers,
  updateUser,
  deleteUser,
  getNewUsersList,
  getCustomerReport,
  getCustomerFollowup,
  getCallStatuses,
  createCallHistory,
  getDeliveryExecutives,
  CustomerExecutiveSalesReport1,
  CustomerExecutiveSalesReport2,
  InvoicedBySalesReport,
  getSalesExecutiveTargets,
  updateSalesExecutiveTarget,
  getCardForCEReport,
  CEPerformanceReport1,
  getCECallStatusPivot,
  getCustomerCallStatusSummary,
  getCEDailyActivityTopcard,
  getSalesExecutiveDailyReport,
  getUnassignedCustomers,
  getLastFiveOrdersfromuserid,
  TotalOrderValue,
  getOrderByOthers,
  getOrderByMe,
  updateCustomerFlagCode,
  saveFlagWithComment,
  getFlagHistory,
  exportAllCustomers
};

export default editUserServices;